/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import { RingProgress } from "@ant-design/plots";
import { ArrowUpOutlined } from "@ant-design/icons";

function RingProgressChartInsights({
    middleTitle = "Test",
    color = "green",
    behaviormatch = "",
    subColor,
    percent = 1
}) {
    const config = {
        percent,
        color: [color, subColor || color],
        innerRadius: 0.9,
        radius: 0.98,
        statistic: {
            title: {
                style: {
                    marginTop: "2mm",
                    color: "#2B3674",
                    fontWeight: "700",
                    fontSize: "24px",
                    lineHeight: "32px"
                },
                formatter: () => middleTitle
            },
            content: {
                style: {
                    marginTop: "1mm",
                    fontWeight: "100",
                    fontSize: "13px",
                    color: "#94A3B8"
                },
                formatter: () => "Interest Level"
            }
        }
    };
    return (
        <div className="ring-progress-chart d-flex-col align-items-center gap-1" style={{ height: "98%", width: "98%", paddingTop: "1mm" }}>
            <RingProgress {...config} />
            <div
                className="d-flex align-items-center gap-1 justify-content-center"
                style={{
                    backgroundColor: subColor,
                    padding: "1mm 4mm",
                    borderRadius: "29px",
                    height: "8mm",
                    width: "98%"
                }}
            >

                <span
                    className="fw-600 fs-12 d-flex align-items-center justify-content-center"
                    style={{
                        backgroundColor: color,
                        color: subColor,
                        borderRadius: "50%",
                        height: "4mm",
                        width: "4mm"
                    }}
                >
                    <ArrowUpOutlined />
                </span>
                <span
                    className="fw-500"
                    style={{
                        color,
                        fontSize: "12px"
                    }}
                >
                    {behaviormatch}
                </span>
            </div>
        </div>
    );
}
export default RingProgressChartInsights;
